import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QuestionListComponent } from '../../question/list';

@Component({
  selector: 'exam-cms-question-container',
  imports: [QuestionListComponent],
  templateUrl: './question-list-container.component.html',
  host: { class: 'flex flex-col h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionListContainerComponent {
  constructor() {}
}
